export const generateProductInformationMessage = ({
  shopName,
  createdAt
}: {
  shopName: string
  createdAt: string
}) => {
  return {
    text: `Conte um pouco mais sobre seu problema. Assim fica mais fácil para o vendedor <strong>${shopName}</strong> ajudar você.`,
    from: 'bot',
    time: createdAt || new Date().toISOString()
  }
}
